

































import Vue from 'vue';

import SearchSelectFilter from './SearchSelectFilter.vue';
import DatetimeFilter from './DatetimeFilter.vue';
import RangeDatetimeFilter from './RangeDatetimeFilter.vue';
import MultiSelectFilter from './MultiSelectFilter.vue';

export default Vue.extend({
    name: 'FilterBar',
    components: {
        SearchSelectFilter,
        DatetimeFilter,
        RangeDatetimeFilter,
        MultiSelectFilter,
    },
    props: {
        /** Объект значений фильтров */
        modelValue: {
            type: Object,
            required: true,
        },
        /** Массив с настройками фильтров по которым строится панель */
        filterSetting: {
            type: Array,
            required: true,
        },
        /** Подпись панели */
        header: {
            type: String,
            required: false,
        },
        /** активность кнопки обновления */
        enableRefresh: {
            type: Boolean,
            required: false,
        },
    },
    model: {
        prop: 'modelValue',
        event: 'input',
    },
    computed: {
        /** активность кнопки обновления */
        disabledRefresh(): boolean | undefined {
            if (this.enableRefresh !== undefined) {
                return !this.enableRefresh;
            }
            return undefined;
        }
    },
    methods: {
        /** Возвращает строку-имя тэга компоента */
        getTagByType(filterType: string): string {
            switch (filterType) {
                case 'search-select':
                    return 'search-select-filter';
                case 'multi-select':
                    return 'multi-select-filter';
                case 'datetime':
                    return 'datetime-filter';
                case 'range-datetime':
                    return 'range-datetime-filter';
                default:
                    return '';
            }
        },
        /** Реагируя на ввод корректирует объект содержфщий фильтры и передает их выше */
        inputHandler(inputObj: { [key: string]: any }) {
            if (
                inputObj.code !== undefined &&
                this.modelValue[inputObj.code] !== inputObj.value
            ) {
                this.modelValue[inputObj.code] = inputObj.value;
                this.$emit('input', this.modelValue);
            }
        },
        refreshHandler() {
            this.$emit('refresh-action');
        },
    }
});
